import axios from "axios"

export const getRelatedPlaces = async (id = "") => {
    if (!id) return;

    try {
        const endpoint = `https://api.vibemap.com/v0.3/search/places/${id}/more_like_this/`
        const res = await axios.get(endpoint)
        const data = res.data

        return data
    } catch (err) {
        console.error({ error: err });
    }
}
